import { create } from 'zustand';
import {
  classifyStorage,
  readStorageEstimate,
  type StorageEstimate,
} from '@/lib/storage-estimate';

/**
 * Browser storage usage cache. Refreshed on app load and after every
 * file upload. Cheap to read — the underlying StorageManager call
 * resolves in milliseconds — but we still cache so the StorageQuotaPanel
 * can render synchronously without flicker.
 */

type State = {
  estimate: StorageEstimate;
  refresh: () => Promise<void>;
};

export const useStorageStore = create<State>((set) => ({
  estimate: classifyStorage(null, null),
  refresh: async () => {
    const next = await readStorageEstimate();
    set({ estimate: next });
  },
}));
